// i18n
import './locales/i18n';

// scrollbar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------
import { SnackbarProvider } from 'notistack';
// routes
import Router from './routes/sections';
// theme
import ThemeProvider from './theme';
// hooks
import { useScrollToTop } from './hooks/use-scroll-to-top';
// components
import { MotionLazy } from './components/animate/motion-lazy';
import { SettingsProvider, SettingsDrawer } from './components/settings';
import { AuthConsumer, AuthProvider } from './auth/context';
// ----------------------------------------------------------------------

export default function App() {

  useScrollToTop();

  return (
    <AuthProvider>
      <SettingsProvider
        defaultSettings={{
          themeMode: 'light', // 'light' | 'dark'
          themeDirection: 'ltr', //  'rtl' | 'ltr'
          themeContrast: 'default', // 'default' | 'bold'
          themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
          themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
          themeStretch: false,
        }}
      >
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={4000}
        >
          <ThemeProvider>
            <MotionLazy>
              <SettingsDrawer />
                  <Router />
            </MotionLazy>
          </ThemeProvider>
        </SnackbarProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
